import type { FormField } from '../schema/types';

type InitialValueProvider = (field: FormField) => unknown;

const initialValueProviders: Record<string, InitialValueProvider> = {
  text: () => '',
  email: () => '',
  phone: () => '',
  textarea: () => '',
};

export function buildInitialValues(
  fields: FormField[],
): Record<string, unknown> {
  return fields.reduce(
    (acc, field) => {
      const provider = initialValueProviders[field.type] ?? (() => '');
      acc[field.name] = provider(field);
      return acc;
    },
    {} as Record<string, unknown>,
  );
}

export function registerInitialValueProvider(
  fieldType: string,
  provider: InitialValueProvider,
): void {
  initialValueProviders[fieldType] = provider;
}
